import { render, staticRenderFns } from "./JXY.vue?vue&type=template&id=1ef544d0&scoped=true"
import script from "./JXY.vue?vue&type=script&lang=js"
export * from "./JXY.vue?vue&type=script&lang=js"
import style0 from "./JXY.vue?vue&type=style&index=0&id=1ef544d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef544d0",
  null
  
)

export default component.exports